import { isIeOrEdge } from './isIEorEDGE';

export function scrollTo(top: number) {
  if (!isIeOrEdge(window.navigator.userAgent)) {
    window.scrollTo({
      top,
      left: 0,
      behavior: 'smooth',
    });

    return;
  }

  window.scrollTo(0, top);
}
